import moment from 'moment';
import { Auth, AuthType } from '@/type';
import { platforms } from '@/iam/external/platform';
import { requestToken, SalesforceTokenResponse } from '../type/oauth/v2';
import { Credentials, CredentialsProvider } from './types';

function resolveExpiresAt(expiresIn: number|null): string|null {
  if (expiresIn === null) return null;
  const expiresAt = moment().unix() + expiresIn;
  return moment.unix(expiresAt).utc().format();
}

const provider:CredentialsProvider = {
  supports(platform: string, auth:Auth): boolean {
    return (auth.type === AuthType.OAUTH && auth.version === '2.0');
  },
  async getCredentials(
    platform: string,
    auth: Auth,
    permissions: string[],
  ): Promise<Credentials|null> {
    const scope = encodeURIComponent(permissions.join(' '));
    const response = await requestToken(platform, scope);
    if (response === null) return null;
    const credentials = {
      accessToken: response.access_token,
      accessTokenExpiresAt: resolveExpiresAt(response.expires_in),
      refreshToken: response.refresh_token,
      refreshTokenExpiresAt: resolveExpiresAt(response.refresh_token_expires_in),
    };
    if (platform === platforms.SALESFORCE) {
      // @ts-ignore
      credentials.instanceUrl = (response as SalesforceTokenResponse).instance_url;
    }
    return credentials;
  },
};

export default provider;
